<template>
  <div>
    <h6 class="mb-2">
      Application Version
    </h6>
    <p class="mb-1">
      <strong>Version:</strong> {{ version }}
    </p>
    <p class="mb-0 text-muted">
      <small><strong>Built:</strong> {{ buildTime }}</small>
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    version() {
      return process.env.VUE_APP_VERSION || 'Unknown'
    },
    buildTime() {
      const buildTime = process.env.VUE_APP_BUILD_TIME
      if (!buildTime) return 'Unknown'

      return new Date(buildTime).toLocaleString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Berlin'
      })
    }
  }
}
</script>

<style scoped>
h6 {
  color: #6c757d;
  font-weight: 600;
}
</style>
